import React, { FC, MouseEventHandler } from 'react';
import styles from './styles.module.css';

export interface ServiceCardProps {
  title: string;
  category?: string;
  isDigital?: boolean;
  onClick?: MouseEventHandler;
  onClickOnlineService?: MouseEventHandler;
}

export const CardServices: FC<ServiceCardProps> = ({
  title,
  category,
  isDigital = false,
  onClick,
  onClickOnlineService,
}) => {
  return (
    <div className={styles.card}>
      <div>
        {category && <div className={styles.category} title={category}>{category}</div>}
        <div className={styles.title} title={title}>{title}</div>
      </div>

      <div className={styles.buttonContainer}>
        <button className={styles.moreInfo} onClick={onClick} type="button">
          Mais Informações
        </button>

        {isDigital && (
          <button className={styles.button} onClick={onClickOnlineService}>
            Solicitar
          </button>
        )}
      </div>
    </div>
  );
};
